import React, {Fragment} from 'react';

const intermediateQuiz = {
    "quizTitle": "Trail Cam Quiz: Intermediate",
    "questions": [
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question1.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Virginia opossum",
                "Woodchuck"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question2.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question3.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question4.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question5.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Robin",
                "Hermit Thrush",
                "Mourning Dove",
                "Wood Thrush"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question6.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Black bear",
                "Raccoon",
                "White-tailed deer",
                "Woodchuck"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question7.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Bobcat",
                "Domestic cat",
                "Lynx",
                "Ocelot"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question8.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Bobcat",
                "Domestic cat",
                "Lynx",
                "Margay"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question9.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Crow",
                "Blue Jay",
                "Common Grackle",
                "Common Raven"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question10.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Coyote",
                "Domestic dog",
                "Gray fox",
                "Red fox"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question11.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question12.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question13.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American beaver",
                "Muskrat",
                "Porcupine",
                "Woodchuck"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question14.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question15.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question16.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Coyote",
                "Domestic dog",
                "Gray fox",
                "Red fox"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question17.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Flying squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question18.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question19.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Woodcock",
                "Mourning Dove",
                "Rock Dove",
                "Ruffed Grouse"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/intermediate/question20.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Elk",
                "Moose",
                "Mule deer",
                "White-tailed deer"
            ],
            "correctAnswer": "4"
        },
    ]
}

export default intermediateQuiz;


// WEBPACK FOOTER //
// ./src/quiz/intermediateQuiz.js